import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';

import { auth } from '../firebase/firebase';
import { useAuth } from './AuthProvider';

function teacherIdentifierToEmail(identifier) {
  const value = String(identifier || '')
    .trim()
    .toLowerCase();

  if (value.includes('@')) {
    return value;
  }

  const cleanIdentifier = value.replace(
    /[^a-z0-9._-]/g,
    ''
  );

  return `${cleanIdentifier}@teachers.le-defi.local`;
}

function accountHome(accountType) {
  if (accountType === 'parent') {
    return '/parent';
  }

  if (
    accountType === 'teacher' ||
    accountType === 'enseignant'
  ) {
    return '/enseignant';
  }

  if (accountType === 'administration') {
    return '/dashboard';
  }

  return '/connexion-enseignant';
}

export default function TeacherLoginPage() {
  const {
    user,
    loading,
    accountType,
    authError
  } = useAuth();

  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Une fois le profil utilisateur chargé,
  // on envoie l'utilisateur vers son espace.
  if (!loading && user) {
    return (
      <Navigate
        to={accountHome(accountType)}
        replace
      />
    );
  }

  async function submit(event) {
    event.preventDefault();

    setError('');
    setSubmitting(true);

    try {
      const email =
        teacherIdentifierToEmail(identifier);

      await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
    } catch (err) {
      console.error(
        'Connexion enseignant :',
        err
      );

      setError(
        'Identifiant ou mot de passe incorrect.'
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-screen">
      <section className="login-card">
        <p className="eyebrow">
          LE DÉFI
        </p>

        <h1>
          Espace enseignant
        </h1>

        <p className="muted">
          Connectez-vous avec l’identifiant fourni
          par l’administration.
        </p>

        <form
          onSubmit={submit}
          className="form-stack"
        >
          <label>
            Identifiant enseignant

            <input
              value={identifier}
              onChange={(event) =>
                setIdentifier(
                  event.target.value
                )
              }
              required
              autoComplete="username"
              placeholder="Exemple : ens.fatma.bensalah"
            />
          </label>

          <label>
            Mot de passe

            <input
              type="password"
              value={password}
              onChange={(event) =>
                setPassword(
                  event.target.value
                )
              }
              required
              autoComplete="current-password"
            />
          </label>

          {(error || authError) && (
            <div className="alert alert-error">
              {error || authError}
            </div>
          )}

          <button
            type="submit"
            className="button button-primary"
            disabled={
              submitting ||
              loading
            }
          >
            {submitting
              ? 'Connexion…'
              : 'Accéder à mon espace'}
          </button>
        </form>
      </section>
    </main>
  );
}